import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Each admin screen rendered its own 1.8rem bold heading with its own
// margins; a couple forgot the description entirely. One header keeps the
// screens looking like one product and gives actions a consistent home.
function PageHeader({ title, description, actions }) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", sm: "flex-end" }}
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Box>
        <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, color: "#1b2a41" }}>
          {title}
        </Typography>
        {description && (
          <Typography sx={{ fontSize: "0.875rem", color: "#7b809a", mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && (
        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
          {actions}
        </Stack>
      )}
    </Stack>
  );
}

PageHeader.defaultProps = { description: "", actions: null };

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
};

export default PageHeader;
